<template>
  <div class="login">
    <div class="container-fluid">
      <div class="row content">
        <div class="col-4 align-self-center">
          <form @submit.prevent="beginLogin" class="form">
            <Logo/>

            <h2 class="header-text text-center">
              {{ $t('login.h2') }}

            </h2>

            <div class="form-group"
                 :class="{ 'invalid': form.data.login !== '' && $v.form.data.login.$error }">
              <div class="d-flex justify-content-between">
                <label>
                  {{ $t('account.phone') }}
                </label>
              </div>
              <phone-input id="login" v-model="form.data.login"/>
            </div>


            <div class="form-group"
                 :class="{ 'invalid': form.data.password !== null && $v.form.data.password.$error }">
              <div class="d-flex justify-content-between">
                <label for="password">
                  {{ $t('login.password') }}
                </label>

                <router-link class="router-link login__forget" :to='{name: "password.forgot"}'>
                  {{ $t('login.restore_password') }}
                </router-link>
              </div>

              <input id="password"
                     type="password"
                     class="form-control"
                     autocomplete="current-password"
                     v-model="form.data.password">
            </div>

            <div class="form-group" v-if='need_sms_code'>
              <label for="sms_code">
                {{ $t('login.sms') }}
              </label>

              <input id="sms_code"
                     type="text"
                     class="form-control"
                     autocomplete="one-time-code"
                     v-model="form.data.sms_code">
            </div>

            <div v-if='form.data.login !== "" && !$v.form.data.login.phoneMaskValidator && $v.form.data.login.$error'
                 class="alert alert-info text-left" role="alert">
              {{ $t('errors.phone_format') }}
            </div>
            <div
                v-if='this.form.errors.invalid_credentials === true || (form.data.login !== "" && form.data.password !== "" && ($v.form.data.login.$error || $v.form.data.password.$error))'
                class="alert alert-info text-left" role="alert">
              {{ $t('errors.credentials') }}
            </div>

            <div v-if='form.errors.invalid_sms_code' class="alert alert-info text-left" role="alert">
              {{ $t('errors.sms') }}
            </div>

            <button type="submit" class="btn btn-primary" :disabled='$v.$invalid || form.sending'>
              {{ $t('login.sign_in') }}
            </button>

            <hr>

            <div class="text-center footer">
              {{ $t('login.account') }}
              <router-link class="router-link" :to='{name:"registration"}'>
                {{ $t('login.sign_up') }}
              </router-link>
            </div>
          </form>
        </div>
      </div>
    </div>
    <LimitErrorModal v-if="limitError"/>
  </div>
</template>

<script>
import {required} from 'vuelidate/lib/validators';
import Logo from '@/components/Logo';
import PhoneInput from '@/components/PhoneInput';
import {mapGetters} from "vuex";
import LimitErrorModal from "@/components/LimitErrorModal";
import {VueRecaptcha} from 'vue-recaptcha';

const phoneMaskValidator = (value) => {
  return value.match(/((\+)?38)?(0\d{2}|\(0\d{2}\))(\d{7}|\d{3}-\d{2}-\d{2})/) === null ? false : true
}
export default {
  name: 'login',
  props: {
    login: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      need_sms_code: false,
      form: {
        data: {
          login: this.login || '',
          password: null,
          sms_code: null,
          sms_token: null,
        },

        errors: {
          //need_sms_code: false,
          invalid_password: false,
          invalid_sms_code: false,
          invalid_credentials: false,
        },
        sending: false,
        credentials_checked: false,
      },
      tokenReCaptcha: '',
      sitekey: process.env.VUE_APP_RECAPTCHA_TOKEN,
    };
  },
  validations() {

    if (!this.need_sms_code) {
      return {
        form: {
          data: {
            login: {
              required,
              phoneMaskValidator
            },
            password: {
              required
            }
          },
        }
      }
    } else {
      return {
        form: {
          data: {
            login: {
              required,
              phoneMaskValidator
            },
            password: {
              required
            },
            sms_code: {
              required
            },
          },
        }
      }
    }

  },
  computed: {
    ...mapGetters([
      'errors',
      'limitError'
    ]),
  },
  methods: {
    beginLogin() {
      this.$v.$touch()
      if (this.$v.$invalid) {
        return false
      }
      this.$store.commit('CLEAR_ERROR')

      const errorCheck = {
        userCredentials: (errorCode) => {
          if (['user-password-mismatch-exception', 'user-login-exception', 'user-not-found-exception'].includes(errorCode)) {
            [this.need_sms_code, this.form.data.sms_code, this.credentials_checked, this.form.errors.invalid_credentials]
                = [false, null, false, true];
          }
        },
        sms: (errorCode) => {
          if (errorCode === 'sms-not-exists-exception' || errorCode === 'sms-expired-exception') {
            this.form.errors.invalid_sms_code = true;
          }
        },
        userNotFound: (errorCode) => {
          if (errorCode === 'user-not-found-exception') {
            this.form.errors.invalid_password = true;
          }
        }
      }
      this.form.sending = true;
      this.form.errors.invalid_credentials = false;

      if (!this.credentials_checked) {
        this.$store.dispatch('checkCredentials', {login: this.form.data.login, password: this.form.data.password})
            .then(() => {
              [this.form.sending, this.credentials_checked] = [false, true];

              if (this.errors.error) {
                let errorCode = this.errors.error.code;
                errorCheck.userCredentials(errorCode)
              } else {
                if (!this.form.data.sms_code) {
                  this.$store.dispatch('sendSms', {
                    type: 'authentication',
                    phone: this.form.data.login,
                    tokenReCaptcha: this.tokenReCaptcha
                  }).then(response => {
                    [this.form.sending, this.form.data.sms_token, this.need_sms_code, this.form.errors.invalid_password]
                        = [false, response.sms_token, true, false];
                  })
                }
              }
            })
      } else {
        if (this.form.data.sms_code) {

          this.$store.dispatch('login', this.form.data).then(() => {
            if (this.errors.error) {
              let errorCode = this.errors.error.code;

              errorCheck.userNotFound(errorCode)
              errorCheck.userCredentials(errorCode);
            } else {
              this.$router.push({
                name: 'profile',
              });
            }
          }).finally(() => this.form.sending = false)
        }
      }
    },
    checkCredentials() {

    },
    setRecaptchaToken(recaptchaToken) {
      this.tokenReCaptcha = recaptchaToken;
      this.beginLogin();

    },
    onCaptchaExpired() {
      this.$refs.recaptcha.reset();
    },
  },
  components: {
    Logo,
    PhoneInput,
    LimitErrorModal,
    VueRecaptcha,
  },
  beforeMount() {
    this.$i18n.locale = 'ua';
    this.$store.dispatch('logout', false);
  },
}
</script>
